import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import { StyledWidgetNav } from './widgetNavbar.styles';
import { IPlatform, IPlugin } from '../../types';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useInView } from 'react-intersection-observer';
import { CustomLink } from '../link/link.comp';

interface IWidgetNavbarProps {
	widget: IPlugin;
	platform?: IPlatform;
	setFormPopupOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const WidgetNavbar = ({
	widget,
	platform,
	setFormPopupOpen,
}: IWidgetNavbarProps) => {
	const router = useRouter();
	const { ref, inView } = useInView({
		threshold: 0,
	});
	const [isBrackets, setIsBrackets] = useState<boolean>(false);

	const overviewPath = `/platforms/${platform?.slug}`;
	const howToAddPath = `/platforms/${platform?.slug}/how-to-add`;

	function renderNavContent() {
		return (
			<div className="links">
				<Link href={'/'} className="logo">
					<Image
						src={widget.logo}
						alt={`${widget.name} ${platform?.title ? `for ${platform.title}` : ''
							} logo`}
						width={30}
						height={30}
					/>
					{widget.name}
				</Link>
				<ul>
					<li>
						<Link
							className={
								router.pathname === `/platforms/[slug]`
									? 'active'
									: ''
							}
							href={overviewPath}
						>
							Overview
						</Link>
					</li>
					{/* {widget.examples?.length > 0 && (
						<li className="examples">
							<Link
								href={'/examples'}
							>
								Examples
							</Link>
						</li>
					)} */}
					{platform && (
						<li className="how-to-add">
							<Link
								className={
									router.pathname === `/platforms/[slug]/how-to-add`
										? 'active'
										: ''
								}
								href={howToAddPath}
							>
								How to add
							</Link>
						</li>
					)}
					{!inView && (
						<>
							<>
								<li>
									<a
										href={`https://www.commoninja.com/embed/website/pricing/bracketsninja?via=brackets`}
									>
										Pricing
									</a>
								</li>
								{/* <li>
									<Link
										href={`/pricing`}
									>
										Pricing
									</Link>
								</li> */}
								<li className="cta-li">
									<CustomLink
										external
										title={`Free ${widget.name} ${platform?.title ? `for ${platform.title}` : ''
											}`}
										href={`https://www.commoninja.com/brackets/editor?via=brackets`}
									>
										Try for free
									</CustomLink>
								</li>
							</>
						</>
					)}
				</ul>
			</div>
		);
	}

	useEffect(() => {
		if (
			typeof window !== 'undefined' &&
			window.location.pathname.includes('brackets')
		) {
			setIsBrackets(true);
		} else {
			setIsBrackets(false);
		}
	}, []);

	return (
		<>
			<StyledWidgetNav ref={ref} className={`${inView ? 'show' : ''}`}>
				{renderNavContent()}
			</StyledWidgetNav>
			<StyledWidgetNav className={`fixed ${!inView ? 'show' : ''}`}>
				{renderNavContent()}
			</StyledWidgetNav>
		</>
	);
};
